import React from "react";
import { useSelector } from "react-redux";

import ReportNoteButtons from "./ReportNoteButtons";
import { ProcessButton } from "./FooterButton";

const EvokeActiveButtons = ({ handleProcess }) => {
  const { hasReportNoteEditAccess } = useSelector(
    (state) => state.transmission
  );

  if (hasReportNoteEditAccess) {
    return <ReportNoteButtons handleProcess={handleProcess} />;
  }

  return <ProcessButton onClick={() => handleProcess("process")} />;
};

export default EvokeActiveButtons;
